import {RegionType} from "@pg-rp/common-types";

type Region = {
    id: number;
    full_name_reverted?: string;
    name?: string;
    type: RegionType;
    parent?: {
        id: number;
        name?: string;
        full_name_reverted?: string;
    } | null;
    stats?: {
        region_type_district: {name: string} | null;
        region_type_county: {name: string} | null;
    } | null;
};

export const getHomeMatchSearchRegions = (regions?: Region[]) => {
    if (!regions) {
        return [];
    }

    // note: value is more important than label, it is used to fetch the region details in search api, after fetch, that label will be overwritten by actual name.
    return regions.map((region) => {
        let regionToSave = {
            value: region.id,
            label: region.full_name_reverted || region.name || ""
        };
        if ((region.type === RegionType.NEIGHBORHOOD || region.type === RegionType.TOWN) && region.parent) {
            regionToSave = {
                value: region.parent.id,
                label:
                    region.full_name_reverted || region.parent.name || region.stats?.region_type_district?.name || region.stats?.region_type_county?.name || ""
            };
        }
        return regionToSave;
    });
};
import {RegionType} from "@pg-rp/common-types";

type Region = {
    id: number;
    full_name_reverted?: string;
    name?: string;
    type: RegionType;
    parent?: {
        id: number;
        name?: string;
        full_name_reverted?: string;
    } | null;
    stats?: {
        region_type_district: {name: string} | null;
        region_type_county: {name: string} | null;
    } | null;
};

export const getHomeMatchSearchRegions = (regions?: Region[]) => {
    if (!regions) {
        return [];
    }

    // note: value is more important than label, it is used to fetch the region details in search api, after fetch, that label will be overwritten by actual name.
    return regions.map((region) => {
        let regionToSave = {
            value: region.id,
            label: region.full_name_reverted || region.name || ""
        };
        if ((region.type === RegionType.NEIGHBORHOOD || region.type === RegionType.TOWN) && region.parent) {
            regionToSave = {
                value: region.parent.id,
                label:
                    region.full_name_reverted || region.parent.name || region.stats?.region_type_district?.name || region.stats?.region_type_county?.name || ""
            };
        }
        return regionToSave;
    });
};
